import { Component, Inject, OnInit } from '@angular/core';
import { EventCalendarDataService } from '../../../event-calendar.data.service';
import { ToasterService } from 'src/app/services/core/toaster.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogService } from 'src/app/services/core/dialog.service';
import { ConfirmationPopupComponent } from 'src/app/modules/shared/confirmation-popup/confirmation-popup.component';
import { NgDialogAnimationService } from 'src/app/services/core/ng-dialog-animation.service';
import { first } from 'rxjs';
import { AddEditCalendarCategoryDialogComponent } from '../add-edit-calendar-category-dialog/add-edit-calendar-category-dialog.component';
import { calendarCategoriesColorOptions } from '../data';
@Component({
    selector: 'app-manage-categories-dialog',
    templateUrl: './manage-categories-dialog.component.html',
    styleUrls: ['./manage-categories-dialog.component.scss'],
    standalone: false
})
export class ManageCategoriesDialogComponent implements OnInit {
  public calendarCategories: any[] = [];
  calendarId: any;
  hasChanged: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ManageCategoriesDialogComponent>,
    private dialogService: DialogService,
    public toasterService: ToasterService,
    public dialog: NgDialogAnimationService,
    public eventCalendarDataService: EventCalendarDataService
  ) {
    this.calendarId = this.data.calendarId;
    console.log('this.calendarId', this.calendarId);

  }

  ngOnInit(): void {
    this.getCategoriesByCalendarId();
  }

  getCategoriesByCalendarId() {
    this.eventCalendarDataService
      .getCategoriesByCalendarId(this.calendarId)
      .subscribe((response: any) => {
        this.calendarCategories = response.data;
      });
  }

  openAddEditCategoryDialog(data: any = '') {
    if (data && data.color && !calendarCategoriesColorOptions.includes(data.color)) {
      calendarCategoriesColorOptions.splice(1, 0, data.color);
    }
    const dialogRef = this.dialog.open(AddEditCalendarCategoryDialogComponent, {
      width: '650px',
      maxWidth: '650px',
      maxHeight: '80vh',
      panelClass: 'add-edit-calendar-category-dialog-container',
      data: {
        itemData: data,
        calendarId:this.calendarId
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.hasChanged = true;
        this.getCategoriesByCalendarId();
      }
    });
  }

  onDeleteConfirmation(id: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      width: '500px',
      height: '300px',
      data: {
        title: 'Remove Category',
        message: 'Are you sure you want to remove selected item?',
        description: '',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.onDelete(id);
      }
    });
  }
  onDelete = (id: any) => {
    this.eventCalendarDataService
      .deleteCalendarCategory(id)
      .pipe(first())
      .subscribe((response) => {
        this.toasterService.showSuccessMessage(response?.message);
        this.calendarCategories = this.calendarCategories?.filter(
          (list: any) => list.id !== id
        );
        this.hasChanged = true;
      });
  };

  close = () => {
    this.dialogRef.close(this.hasChanged);
  };
}
